/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateWorkItemStatusRequestDto { 
    /**
     * New status for the work item. If not provided, only statusReason will be updated.
     */
    newStatus?: UpdateWorkItemStatusRequestDto.NewStatusEnum;
    /**
     * Status reason text/comment
     */
    statusReason?: string;
}
export namespace UpdateWorkItemStatusRequestDto {
    export type NewStatusEnum = 'open' | 'closed' | 'on-hold';
    export const NewStatusEnum = {
        Open: 'open' as NewStatusEnum,
        Closed: 'closed' as NewStatusEnum,
        OnHold: 'on-hold' as NewStatusEnum
    };
}


